/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetGetConfiguratorQuantityStepQueryResponse, GetGetConfiguratorQuantityStepPathParams, GetGetConfiguratorQuantityStepQueryParams, GetGetConfiguratorQuantityStep401, GetGetConfiguratorQuantityStep403, GetGetConfiguratorQuantityStep404 } from "../../models/GetGetConfiguratorQuantityStep";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetGetConfiguratorQuantityStepUrl({ code }: { code: GetGetConfiguratorQuantityStepPathParams["code"] }) {
  const res = { method: 'GET', url: `/api/v1/products/${code}/configurator/steps/quantity` as const }  
  return res
}

/**
 * {@link /api/v1/products/:code/configurator/steps/quantity}
 */
export async function getGetConfiguratorQuantityStep({ code, params }: { code: GetGetConfiguratorQuantityStepPathParams["code"]; params: GetGetConfiguratorQuantityStepQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetGetConfiguratorQuantityStepQueryResponse, ResponseErrorConfig<GetGetConfiguratorQuantityStep401 | GetGetConfiguratorQuantityStep403 | GetGetConfiguratorQuantityStep404>, unknown>({ method : "GET", url : getGetGetConfiguratorQuantityStepUrl({ code }).url.toString(), params, ... requestConfig })  
  return res.data
}